import React from "react";
import { getAllStocksData } from "../../services/TradingMallService";
import { SectionHeader } from "./HeaderSection";
import TopCategoriesClient from "./TopCategoriesClient";
import {
  textEllipsis,
  TITLE_CHAR_LIMIT,
  SUB_TITLE_CHAR_LIMIT,
} from "./clpCardConstant";
import { ComponentContent, StockTab } from "../../types/stocks";

interface TopCategoriesProps {
  content?: ComponentContent;
}

export const TopCategories: React.FC<TopCategoriesProps> = async ({
  content,
}) => {
  const [topgainers, toplosers, weekshigh, weekslow] = await Promise.all([
    getAllStocksData({ exchId: "0", entity: "topgainers" }),
    getAllStocksData({ exchId: "0", entity: "toplosers" }),
    getAllStocksData({ exchId: "0", entity: "52weekhigh" }),
    getAllStocksData({ exchId: "0", entity: "52weeklow" }),
  ]);

  const stocksData = { topgainers, toplosers, weekshigh, weekslow };

  return (
    <section className="px-4 py-3">
      <SectionHeader
        action=""
        title={textEllipsis(
          content?.componentTitle || "Top Categories",
          TITLE_CHAR_LIMIT,
        )}
        description={textEllipsis(
          content?.componentDescription || "View stocks across key categories.",
          SUB_TITLE_CHAR_LIMIT,
        )}
      />
      <TopCategoriesClient
        stocksData={stocksData}
        defaultImage={content?.defaultImageLink}
        tabs={Object.values(content?.tabs?.[0] || {}) as StockTab[]}
        viewAllLabel={content?.label || "View all"}
        stockNotFoundText={content?.stockNotFoundText || "No stocks found."}
        stockNotFoundImgUrl={content?.stockNotFoundImgUrl || ""}
        modalTitle={content?.modalTitle}
        modalBtnCta={content?.modalBtnCta}
        successMsg={content?.successMsg}
        errorMsg={content?.errorMsg}
      />
    </section>
  );
};
